import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['zipcode', 'submit']

  connect () {
    this.validate()
  }

  get className () {
    return this.element.dataset.classname
  }

  get disabledClass () {
    return `${this.className}::disabled`
  }

  validate () {
    const zipcode = this.zipcodeTarget.value.replace(/\D/g, '')
    const isValid = zipcode.length === 7

    if (isValid) {
      this.submitTarget.classList.remove(this.disabledClass)
    } else {
      this.submitTarget.classList.add(this.disabledClass)
    }
  }
}
